import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
      <h1 className="timeline-title">
        <FontAwesomeIcon icon={faBriefcase} className="title-icon" />
        Career History
      </h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="June 2025 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">School Counsellor</h3>
            <h4 className="vertical-timeline-element-subtitle">National Public School, Bengaluru</h4>
            <p>
              Psychology Education, Student Counselling, Workshop Design, Emotional Intelligence, Well-being Programs
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2024 - May 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Child and Adolescent Counsellor</h3>
            <h4 className="vertical-timeline-element-subtitle">Cadabams Hospitals, Bengaluru</h4>
            <p>
              Student Counseling, Emotional Well-being Sessions, Parent Workshops, Behavioral Support
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Nov 2022 - Jan 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Psychology Lecturer</h3>
            <h4 className="vertical-timeline-element-subtitle">KLE Lingaraj PU College, Belgaum</h4>
            <p>
              Psychology Teaching, Interactive Learning, Practical Sessions, Educational Visits
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="April 2022 - Sep 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Consultant Psychologist</h3>
            <h4 className="vertical-timeline-element-subtitle">Samarth Neuropsychiatry Clinic, Belgaum</h4>
            <p>
              Psychometric Testing, MMSE Assessment, Therapeutic Interventions, Clinical Case Work
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2021 - Sep 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Psychology Lecturer and Counsellor</h3>
            <h4 className="vertical-timeline-element-subtitle">Vijaya Hospital and Physiotherapy College, Belgaum</h4>
            <p>
              Psychology Education, Student Counseling, Mental Health Awareness, Experiential Learning
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2020 - Jan 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Counsellor</h3>
            <h4 className="vertical-timeline-element-subtitle">Podar International School, Belgaum</h4>
            <p>
              Special Needs Counseling, Parent Support, Mental Health Workshops, Staff Counseling
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;